module.exports = __webpack_public_path__ + "static/media/topResult.b855ae9f.svg";